export default __webpack_public_path__ + "media/images/elephant_ui_disappointed_sub.png.old-4b3678e15e336e47e5ac981e9a0b194f.png";